import { render, staticRenderFns } from "./Form50Attendance.vue?vue&type=template&id=0b83e31c&scoped=true&"
import script from "./Form50Attendance.vue?vue&type=script&lang=js&"
export * from "./Form50Attendance.vue?vue&type=script&lang=js&"
import style0 from "./Form50Attendance.vue?vue&type=style&index=0&id=0b83e31c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b83e31c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VFlex,VLayout,VSelect})
